module.exports = __webpack_public_path__ + "assets/img/semenko.b85f0f92.webp";